import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../config/config";
import Swal from 'sweetalert2';


function Login() {
    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const response = await fetch(`${config.apiUrl}/usuarios/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ correo: user, contrasena: password }),
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem("auth", "true");
                localStorage.setItem("nombre", data.nombre); // Guarda el nombre del usuario
                localStorage.setItem("tipo_usuario", data.tipo_usuario); // 🔹 Guarda el rol
                mostrarAlerta();
                navigate("/"); // 🔹 Redirige a la página principal
            } else {
                setError(data.message || "Credenciales incorrectas");
            }
        } catch (error) {
            setError("Error en la conexión con el servidor");
        }
    };

    const mostrarAlerta = () => {
        Swal.fire({
            title: '¡Éxito!',
            text: 'Login exitoso',
            icon: 'success',
            confirmButtonText: 'Aceptar'
        });
    };


    return (
        <div
            className="d-flex justify-content-center align-items-center vh-100"
            style={{
                backgroundImage: "url('/login.jpg')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="col-10 col-sm-8 col-md-6 col-lg-4">
                <form onSubmit={handleLogin} className="card p-4 shadow"
                      style={{background: "rgba(255, 255, 255, 0.9)"}}>
                    <h3 className="text-center">Iniciar Sesión</h3>
                    {error && <div className="alert alert-danger">{error}</div>}
                    <div className="mb-3">
                        <label htmlFor="usuario" className="form-label">Correo</label>
                        <input
                            type="email"
                            className="form-control"
                            id="usuario"
                            placeholder="Correo electrónico"
                            value={user}
                            onChange={(e) => setUser(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="contraseña" className="form-label">Contraseña</label>
                        <input
                            type="password"
                            className="form-control"
                            id="contraseña"
                            placeholder="Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100">Login</button>
                </form>
            </div>
        </div>
    );
}

export default Login;
